import unescape from 'lodash/unescape';
import {getExpireTime} from '../../../common/shared/utils/getExpireTime';
import {NOTICE_NUM_PER_PAGE} from '../../../design-system/pages/Notice/NoticeNumPerPage.constant';
import {
  AnnouncementContainerFragment,
  AnnouncementFragment,
} from '../../../graphql/generated/types';
import {NoticeData, NoticeItem} from '../type';

export function getNoticeData(data: AnnouncementContainerFragment): NoticeData {
  return {
    expireTime: getExpireTime(),
    totalCount: data.totalCount,
    items: getNoticeItems(data.items),
    maxPage: Math.ceil(data.totalCount / NOTICE_NUM_PER_PAGE),
  };
}

function getNoticeItems(items: AnnouncementFragment[]): NoticeItem[] {
  return items.map(item => ({
    id: item.id,
    title: unescape(item.title),
    contents: item.contents,
    createDt: new Date(item.createDt),
  }));
}
